<template>
    <div class="brt-scroll-module">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Scroll"
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    .brt-scroll-module {
        border: 1px solid @BorderColorA2;
        border-radius: 3px;
        overflow-y: auto;
    }

</style>
